<template>
  <form-wrapper
    title="Main Header Settings"
    :hint-images="hint"
  >
    <choose-image
      title="Click on image to chose logo for header"
      v-model="settings.logoImage"
    />
    <color-settings
      title="Choose background color"
      :color.sync="settings.background"
    />
    <v-flex xs6>
      <font-settings
        title="Links fonts settings"
        has-hover-color
        :settings.sync="settings.linksFont"
      />
    </v-flex>

    <reset-submit
      @submit="generateSubmit('header')"
      @reset="resetSettings"
    />

  </form-wrapper>
</template>

<script>
import FontSettings from './../styleSettingsFormComponents/FontSettings'
import ColorSettings from './../styleSettingsFormComponents/ColorSettings'
import ChooseImage from './../styleSettingsFormComponents/ChooseImage'
import FormWrapper from './FormWrapper'
import ResetSubmit from './../styleSettingsFormComponents/ResetSubmit'
import { submitGlobalStyles } from '@/utils/mixins'

import {
  generateDefaultColor,
  generateDefaultLinkParams,
  generateMapState
} from './utils'

export default {
  name: 'FooterStyleSettings',
  components: {
    FontSettings,
    ColorSettings,
    ChooseImage,
    FormWrapper,
    ResetSubmit
  },
  mixins: [submitGlobalStyles],
  data () {
    return {
      settings: {
        logoImage: null,
        background: generateDefaultColor(),
        linksFont: generateDefaultLinkParams()
      },
      hint: [
        {url: '/static/info/Header_img.png', title: 'Header' },
        {url: '/static/info/Header_menu.png', title: 'Header' }
      ]
    }
  },
  computed: {
    ...generateMapState('header')
  }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/MainHeaderSettings.vue